/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_6_AInputs */

const en_vc_faq_6_a = /** @type {(inputs: Vc_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. A few unrelated products use the same name, including a Figma plugin that converts bitmaps to SVG. This page covers the open-source vector editor from the ArtCraft team.`)
};

const zh_vc_faq_6_a = /** @type {(inputs: Vc_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是。有几款不相关的产品也叫这个名字，比如一个把位图转成 SVG 的 Figma 插件。本页介绍的是 ArtCraft 团队的开源矢量编辑器。`)
};

/**
* | output |
* | --- |
* | "No. A few unrelated products use the same name, including a Figma plugin that converts bitmaps to SVG. This page covers the open-source vector editor from th..." |
*
* @param {Vc_Faq_6_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_6_a = /** @type {((inputs?: Vc_Faq_6_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_6_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_6_a(inputs)
	return zh_vc_faq_6_a(inputs)
});
export { vc_faq_6_a as "vc.faq.6.a" }